export default function Leaderboard({ rows, yourWinnerId }) {
  return (
    <section aria-labelledby="leaderboard-heading" className="w-full">
      <h2 id="leaderboard-heading" className="text-2xl font-extrabold text-showdown-blue sm:text-3xl">
        People&rsquo;s Choice Leaderboard
      </h2>
      <p className="mt-1 text-xs text-showdown-cream/60 sm:text-sm">
        Ranked by final-round votes. Ties are ranked by head-to-head round wins.
      </p>

      <ol className="mt-4 flex flex-col gap-3">
        {rows.map((row, index) => {
          const isYours = row.id === yourWinnerId;
          return (
            <li
              key={row.id}
              className={`flex items-center gap-3 rounded-2xl p-3 shadow sm:gap-4 sm:p-4 ${
                isYours ? 'bg-showdown-pink/20 ring-2 ring-showdown-pink' : 'bg-showdown-ink'
              }`}
            >
              <span
                className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-black text-base font-extrabold sm:h-11 sm:w-11 sm:text-lg"
                aria-hidden="true"
              >
                {index + 1}
              </span>

              <img
                src={row.poster}
                alt=""
                className="h-14 w-14 shrink-0 rounded-xl object-cover sm:h-16 sm:w-16"
                onError={(e) => {
                  e.currentTarget.style.visibility = 'hidden';
                }}
              />

              <div className="min-w-0 flex-1">
                <p className="break-words text-base font-bold leading-tight sm:text-lg">
                  {row.name}
                  {isYours && (
                    <span className="ml-2 inline-block rounded-full bg-showdown-pink px-2 py-0.5 align-middle text-[10px] font-extrabold uppercase tracking-wide text-showdown-ink sm:text-xs">
                      Your pick
                    </span>
                  )}
                </p>
                <p className="text-sm text-showdown-cream/70 sm:text-base">
                  {row.finalVotes} vote{row.finalVotes === 1 ? '' : 's'}
                </p>
              </div>

              <div className="shrink-0 text-right text-xl font-extrabold text-showdown-pink sm:text-2xl">
                {row.percentage.toFixed(0)}%
              </div>
            </li>
          );
        })}
      </ol>
    </section>
  );
}
